import LoginHeader from '../LoginHeader';
import LoginTitle from '../LoginTitle';

interface IWaitlistedStepProps {
  onBack: () => void;
}

const WaitlistedStep = ({ onBack }: IWaitlistedStepProps) => {
  return (
    <>
      <LoginHeader onBack={onBack} />
      <LoginTitle
        title="You're on the waitlist"
        subtitle="We'll notify you when your account is ready. Thanks for your interest."
      />
    </>
  );
};

WaitlistedStep.displayName = 'WaitlistedStep';

export default WaitlistedStep;
